import React, { Component } from 'react';
import Link from 'gatsby-link';
import HeroContainer from '../components/ui/HeroContainer';
import Carousel from '../components/ui/Carousel';
import Helmet from 'react-helmet';

class Homepage extends Component {
  state = {
    revealText: false,
  };
  componentDidMount() {
    setTimeout(() => {
      this.setState({ revealText: true });
    }, 500);
    this.props.resetDisplaySettings();
  }
  render() {
    // hardcoding order
    const slideData = [
      this.props.data.homeSlides.edges.find(
        data => data.node.post_type === 'exhibition'
      ),
      this.props.data.homeSlides.edges.find(
        data => data.node.post_type === 'timeline'
      ),
      this.props.data.homeSlides.edges.find(
        data => data.node.post_type === 'tour'
      ),
      ...this.props.data.otherSlides.edges,
    ];
    return (
      <HeroContainer
        top
        exiting={
          this.props.transition && this.props.transition.status === 'exiting'
        }
      >
        <Helmet title={`The House on Henry Street`} />
        <Carousel
          introIsShowing={this.props.introIsShowing}
          slideData={slideData}
          revealText={this.state.revealText}
        />
      </HeroContainer>
    );
  }
}

export default Homepage;

export const homeQuery = graphql`
  query homeData {
    homeSlides: allDataJson(
      filter: { post_type: { regex: "/tour|exhibition|timeline/" } }
    ) {
      edges {
        node {
          path
          post_type
          home_headline
          home_body
          home_cta_text
          home_image {
            url
            alt
            sizes {
              large
            }
          }
        }
      }
    }
    otherSlides: allDataJson(filter: { show_on_homepage: { eq: true } }) {
      edges {
        node {
          path
          post_type
          home_headline
          home_body
          home_cta_text
          home_image {
            url
            alt
            sizes {
              large
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js